import React from 'react';
import styled from 'styled-components';

export const CenteredImage = styled.img`
  width: 100%;
  //changes for image scaled up on hover
  // &:hover{
  //   transform:scale(1.2);
  // }
`;

const CenteredProductImage = ({ images, sizes, alt }) => {
  return <CenteredImage src={images.thumbnailUrl} sizes={sizes} alt={alt} />;
};

export default CenteredProductImage;
